<template>
  <div class="mv_agent">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'电影台'},{name:'代理商管理'}]"></breadcrumb>
    <div class="mv_agent-wrap">
      <div class="mv_agent-contain">
        <mv-top-nav>
          <el-button type="primary"
                     @click="addAgent()">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">新增代理</span>
          </el-button>
        </mv-top-nav>
        <div class="mv_agent-search_wrap">
          <div class="mv_agent-search_top">
            <div class="mv_agent-search_left">
              <el-select clearable
                         @change="searchChange()"
                         placeholder="全部省份"
                         v-model="params.provid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
                <el-select
                placeholder="请选择"
                clearable
                         @change="searchChange()"
                         v-model="params.type">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </div>
            <div class="mv_agent-search_right">
              <a class="mv_agent-table_download"
                 @click="exportExcel()">
                <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                   :icon="['fas', 'level-up-alt']" />导出Excel
              </a>
              <el-input clearable
                        prefix-icon="el-icon-search"
                        v-model="params.name"
                        @keyup.enter.native="searchChange()"
                        @clear="searchChange()"
                        placeholder="搜索代理商"></el-input>
            </div>
          </div>
        </div>
        <div class="mv_agent-table-wrap">
          <div class="mv_agent-table">
            <table>
              <tr>
                <th>代理商名称</th>
                <th>省份</th>
                <th>类型</th>
                <th>联系人</th>
                <th>电话</th>
                <th>客户数量</th>
                <th>日期</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item,index) in agentList"
                  :key="item.id">
                <td><a @click="goDetail(item.id)">{{item.name}}</a></td>
                <td>{{item.provName}}</td>
                <td>{{item.typeName}}</td>
                <td>{{item.contact}}</td>
                <td>{{item.phoen}}</td>
                <td>{{item.clientCount}}</td>
                <td>{{item.createTime.split('T')[0]}}</td>
                <td>
                  <el-dropdown trigger="click">
                    <div class="mv_agent-more_button">
                      <i class="el-icon-more"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <div @click="edit(index)">
                          <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                             :icon="['fas', 'pencil-alt']" />编辑
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <div @click="delAgent(item.id)">
                          <font-awesome-icon style="color:#d0021b; margin-right:6px;"
                                             :icon="['fas', 'minus-circle']" />删除
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="params.page"
                         class="mv_agent-pagination"
                         background
                         layout="prev, pager, next"
                         :total="listSize"></el-pagination>
        </div>
      </div>
    </div>
    <!--代理商表单-->
    <el-dialog class="mv_agent-dialog"
               title="代理商信息"
               :visible.sync="agentFormShow">
      <el-form label-position="top"
               class="mv_agent-form">
        <el-row :gutter="15">
          <el-col :span="16">
            <el-form-item label="代理商名称">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="省份">
              <el-select clearable
                         placeholder="请选择"
                         v-model="agentForm.provid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="类别">
              <el-select clearable
                         placeholder="请选择"
                         v-model="agentForm.type">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.position"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="手机">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.phoen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="固话">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.telephoen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.fax"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="16">
            <el-form-item label="地址">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.addr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮编">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.postcode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="备注">
              <el-input clearable
                        placeholder="请输入"
                        v-model="agentForm.content"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitAgentForm">提 交</el-button>
        <el-button @click="agentFormShow= false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import mvTopNav from '@/components/mvTopNav'
export default {
  components: {
    breadcrumb,
    mvTopNav
  },
  data() {
    return {
      params: {
        page: 0,
        pageSize: 10,
        provid: '',
        type: '',
        name: ''
      },
      listSize: 0,
      agentList: [],

      platformList: [],
      providList: [],

      agentFormShow: false,
      agentForm: {
        addr: '',
        contact: '',
        content: '',
        fax: '',
        name: '',
        phoen: '',
        position: '',
        postcode: '',
        provid: '',
        telephoen: '',
        type: ''
      },

      downloadSrc: ''
    }
  },
  created() {
    this.getList()
    this.getSelectList()
  },
  methods: {
    getList() {
      axios
        .post(api.agentinfoList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取代理商列表成功', res.data.result)
            this.agentList = res.data.result.records
            this.listSize = res.data.result.total
          } else {
            console.log('获取代理商列表失败', res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    getSelectList() {
      Promise.all([
        //获取类别
        axios.get(api.getMovTypeList).then(res => {
          if (res.data.code === 0) {
            console.log('获取类别成功', res.data.result)
            this.platformList = res.data.result
          } else {
            console.log('获取类别失败', res.data.msg)
          }
        }),
        //获取省-市-区列表
        axios.post(api.areaListAuth).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，稍后重试')
        })
    },
    changePage(v) {
      this.params.page = v
      this.getList()
    },
    searchChange() {
      this.params.page = 1
      this.getList()
    },
    edit(index) {
      this.agentForm = _.pick(this.agentList[index], _.keys(this.agentForm))
      this.agentForm.id = this.agentList[index].id
      this.agentFormShow = true
    },
    delAgent(id) {
      this.$confirm('删除后不可恢复，确认删除？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        axios
          .get(api.deleteagent + `?id=${id}`)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '删除代理商成功',
                type: 'success'
              })
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      })
    },
    //添加代理商
    addAgent() {
      this.agentForm = {
        addr: '',
        contact: '',
        content: '',
        fax: '',
        name: '',
        phoen: '',
        position: '',
        postcode: '',
        provid: '',
        telephoen: '',
        type: ''
      }
      this.agentFormShow = true
    },
    //提交代理商表单
    submitAgentForm() {
      let params = _.cloneDeep(this.agentForm)
      if (params.id) {
        axios
          .post(api.updateAgent, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改代理商成功',
                type: 'success'
              })
              this.agentFormShow = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      } else {
        axios
          .post(api.addagent, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '添加代理商成功',
                type: 'success'
              })
              this.agentFormShow = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      }
    },
    //查看详情
    goDetail(id) {
      this.$router.push({ path: `/mv_channel/agent_detail/${id}` })
    },
    //导出excel
    exportExcel() {
      let params = {
        provid: this.params.provid,
        type: this.params.type,
        name: this.params.name
      }
      axios({
        // 用axios发送post请求
        method: 'post',
        url: api.agentinfoExport,
        data: params,
        responseType: 'blob' // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '电影台代理商列表.xls'
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    }
  }
}
</script>

<style lang="scss">
.mv_agent {
  .mv_agent-wrap {
    padding: 77px 30px 0px 30px;
    .mv_agent-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .mv_agent-search_wrap {
        position: relative;
        .mv_agent-search_top {
          background: #f8f8f8;
          padding: 20px 27px;
          display: flex;
          justify-content: flex-end;
          .mv_agent-search_left {
            display: flex;
            flex: 1;
            .el-select {
              width: 130px;
              margin-right: 13px;
            }
          }
          .mv_agent-search_right {
            display: flex;
            .mv_agent-table_download {
              text-decoration: none;
              cursor: pointer;
              width: 108px;
              height: 38px;
              border-radius: 4px;
              background: #fff;
              margin-right: 10px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 38px;
              text-align: center;
            }
            .el-input {
              width: 178px;
            }
          }
        }
      }
      .mv_agent-table-wrap {
        padding: 30px 30px 30px 30px;
        .mv_agent-table_title {
          color: #9b9b9b;
          span {
            color: #f0722b;
          }
        }
        .mv_agent-table {
          margin-top: 16px;
          min-height: 470px;
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;
              .mv_agent-more_button {
                width: 50px;
                height: 26px;
                cursor: pointer;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(220, 223, 230, 1);
                display: flex;
                align-items: center;
                justify-content: center;
                i {
                  color: #9b9b9b;
                }
              }

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .mv_agent-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .mv_agent-dialog {
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }
    .mv_agent-form {
      .mv_agent-title {
        color: #4a4a4a;
        font-weight: 600;
        font-size: 18px;
      }
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
        .el-radio-group {
          height: 40px;
          align-items: center;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-checkbox-group {
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-date-editor {
          width: 100%;
        }
      }
      .mv_agent-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
}
</style>
